import { Fragment } from "react";
import Link from "next/link";
import getConfig from "next/config";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const isBricoStore = settings.websiteName === "bricostore";

// Brico: match the site breadcrumbs (components/Breadcrumbs.js) — brand red + text-sm,
// instead of the promo-only magenta #C50244; altex/MG keep the original look.
const linkClass = `${
  isBricoStore ? "text-red-brand" : "text-[#C50244]"
} group-with-promoDarkTheme:text-white`;

const PromoBreadcrumbs = ({ breadcrumbs, campaignSlug }) => (
  <div className={isBricoStore ? "text-sm" : "text-xs"}>
    <Link href={`${settings.baseUrl}/promo/${campaignSlug}/`}>
      <a title="" className={linkClass}>
        Pagina principala
      </a>
    </Link>

    {breadcrumbs.map((breadcrumb, index) => (
      <Fragment key={index}>
        <span className={linkClass}>{" / "}</span>

        {breadcrumb.active ? (
          <span className="text-gray-text">{breadcrumb.name}</span>
        ) : (
          <Link
            href={`${settings.baseUrl}/promo/${campaignSlug}/${breadcrumb.slug}/`}
          >
            <a title="" className={linkClass}>
              {breadcrumb.name}
            </a>
          </Link>
        )}
      </Fragment>
    ))}
  </div>
);

export default PromoBreadcrumbs;
